import loginPrompt from './loginPrompt';
import abandonCheckout from './abandonCheckout/index';
import { tradePromosConfig } from './tradePromos/tradePromosConfig';
import tradeProgramAnnouncement from './tradeProgramAnnouncement';
import { tradeGeneralOnboardingConfig } from './tradeGeneralOnboarding/tradeGeneralOnboardingConfig';
import { privacyPolicyChangeNoticeConfig } from './privacyPolicyChangeNotice/privacyPolicyChangeNoticeConfig';
import tradeRewardsLevelUp from './tradeRewardsLevelUp';

export default [
    ...abandonCheckout,
    loginPrompt,
    privacyPolicyChangeNoticeConfig,
    tradeGeneralOnboardingConfig,
    tradeProgramAnnouncement,
    ...tradePromosConfig,
    tradeRewardsLevelUp,
];
